import { render } from "./FinalQA-Form.vue?vue&type=template&id=9229b8e0&scoped=true"
import script from "./FinalQA-Form.vue?vue&type=script&lang=js"
export * from "./FinalQA-Form.vue?vue&type=script&lang=js"

import "./FinalQA-Form.vue?vue&type=style&index=0&id=9229b8e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9229b8e0"]])

export default __exports__